var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-card',{attrs:{"no-body":""}},[_c('b-card-header',[_c('b-card-title',{staticClass:"mb-50"},[_vm._v(" "+_vm._s(_vm.title)+" ")])],1),_c('b-card-body',[_c('div',{ref:"Expiration",style:({ width: '100%', height: '300px' })})])],1)}
var staticRenderFns = []

export { render, staticRenderFns }